import React, { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Form } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import QuestionPreview from './QuestionPreview'
import { ReactSortable } from 'react-sortablejs'
import { StyledErrorLabel } from '../style'
interface SelectProps {
  languageIndex: number
  type: string
  remove: (index: number) => void
  fields: any[]
  append: () => void
  multiple?: boolean
  sort?: boolean
  swap?: (indexA: number, indexB: number) => void
}

const Select: React.FC<SelectProps> = (props) => {
  const { languageIndex, remove, append, fields, sort, swap } = props
  const { t } = useTranslation()
  const { control, setValue, setError, clearErrors } = useFormContext()
  const watchQuestions = useWatch({ control, name: `languages[${languageIndex}].question` })
  const watchPlaceholder = useWatch({ control, name: `languages[${languageIndex}].placeholder` })
  const watchAnwser = useWatch({ control, name: 'answers' })
  const watchReq = useWatch({ control, name: 'required' })
  const watchMin = useWatch({ control, name: 'requiredMin' })

  useEffect(() => {
    if (fields.length < watchMin) {
      setError('answers', {
        message: t('Number of answers should be at least min. required ({{watchMin}})', { watchMin })
      })
    } else {
      clearErrors('answers')
    }
  }, [fields])

  function renderAnswers() {
    return <>
      {fields.map((anwser, index) => {
        return <div key={anwser.key} style={{ display: 'flex', alignItems: 'center' }}>
          <FormFields.Input
            control={control}
            width={12}
            name={`answers[${index}].languages[${languageIndex}].answer`}
            label={t('Answer {{index}}', { index: index + 1 })}
            placeholder={t('Enter answer')}
            rules={{
              required: {
                value: true,
                message: t('Please enter anwser')
              }
            }}
          />
          <Form.Button
            style={{ marginLeft: 10, marginTop: 7 }}
            onClick={() => remove(index)}
            size={'small'}
            basic
            color='red'
            type={'button'}
            icon='trash'
          />
        </div>
      })}
      <Button
        type='button'
        style={{ color: 'white' }}
        content={t('Add')}
        icon='plus'
        labelPosition='left'
        onClick={() => append()}
      />
      {fields.length < watchMin && <StyledErrorLabel basic pointing>
        {t('Number of answers should be at least min. required ({{watchMin}})', { watchMin })}
      </StyledErrorLabel>}
    </>
  }

  function renderSelectAnswers() {
    return <Form.Select
      label={<div style={{ display: 'flex' }}>
        <div style={{ marginBottom: '1em' }}>{watchQuestions}</div>
        {Boolean(watchReq) && <span style={{ color: 'red' }}>*</span>}
      </div>}
      upward
      multiple={props.multiple}
      placeholder={watchPlaceholder}
      selectOnBlur={false}
      options={watchAnwser?.map((answer) => ({ text: answer.languages[languageIndex].answer, value: Math.random() }))}
    />
  }

  function renderSortItems() {
    return watchAnwser.map((answer, index) => {
      return <div className='question-name' key={answer.id}>
        {`${index + 1}. ${answer.languages[languageIndex].answer}`}
      </div>
    })
  }

  function renderSortAnswers() {
    return <>
      <Form.Field label={watchQuestions} required={Boolean(watchReq)} />
      <ReactSortable
        list={fields}
        animation={150}
        delayOnTouchOnly={true}
        delay={2}
        setList={(newState) => setValue('answers', newState)}
      >
        {renderSortItems()}
      </ReactSortable>
    </>
  }

  function renderPreview() {
    return <QuestionPreview>
      {sort ? renderSortAnswers() : renderSelectAnswers()}
    </QuestionPreview>
  }

  return <>
    <FormFields.TextArea
      control={control}
      label={t('Type in your question')}
      placeholder={t('Type in your question')}
      name={`languages[${languageIndex}].question`}
      rules={{
        required: {
          value: true,
          message: t('Please enter question')
        }
      }}
    />
    <FormFields.Input
      control={control}
      label={t('Placeholder')}
      placeholder={t('Placeholder')}
      name={`languages[${languageIndex}].placeholder`}
    />
    {renderAnswers()}
    {renderPreview()}
  </>
}
export default Select